import { createFeatureSelector, createSelector } from '@ngrx/store';
import { StatesState } from './states.reducer';

export const STATE_FEATURE_KEY = 'states';

export const getStatesState = createFeatureSelector<StatesState>(STATE_FEATURE_KEY);
export const getAllStates = createSelector(getStatesState, ({ entities }) => entities);
